import * as z from "zod";

import { contractWithCounterPartySchema } from "./contract-with-counter-party";
import { organizationWithContactSchema } from "./organization-with-contact";
import { procurementSchema } from "./procurement";
import { procurementOrganizationSchema } from "./procurement-organization";
import { userSchema } from "./user";

export const procurementWithCreatedByAndOrganizationsSchema =
  procurementSchema.extend({
    createdBy: userSchema,
    organizations: z.array(procurementOrganizationSchema).default([]),
    winner: organizationWithContactSchema.optional(),
    contract: contractWithCounterPartySchema.optional(),
  });

export type ProcurementWithCreatedByAndOrganizations = z.infer<
  typeof procurementWithCreatedByAndOrganizationsSchema
>;
